<script setup>
import InputError from '@/Components/InputError.vue';
// import InputLabel from '@/Components/InputLabel.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';
import { Link, router, useForm } from '@inertiajs/vue3';
import { reactive, ref, watch } from 'vue';

import {
    signOut,
    createUserWithEmailAndPassword,
} from 'firebase/auth';
import { useFirebaseAuth } from 'vuefire';
import { onMounted } from 'vue';

import { locale } from '@/Localization.js';
import { trans, transChoice } from 'laravel-vue-i18n';

const processing = ref(null);

const auth = useFirebaseAuth(); // only exists on client side

const form = useForm({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    password_confirmation: '',
});

const handleSignOut = () => {
    signOut(auth).then(() => {
        router.post(route('logout'));
    });
};

const handleSignUp = () => {

    // console.debug('RegisterForm.handleSignUp()');

    var email = form.email;
    var password = form.password;
    var password_confirmation = form.password_confirmation;

    form.clearErrors();

    if (password != password_confirmation) {
        form.errors = {
            password: trans("form.error.password_no_match"),
        };

        console.error('form.errors', form.errors);

        return false;
    }

    processing.value = true;

    if (auth.currentUser) {
        handleSignOut();
    }

    createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {

            // console.debug('createUserWithEmailAndPassword()');

            processing.value = false;

            // Signed in 
            // const user = userCredential.user;
            // console.log('user', user);

            var location = route('auth.profile');

            // console.debug('startsWith', {
            //     route: route().current(),
            //     auth: route().current().startsWith('auth.'),
            //     location: location
            // });

            if (route().current().startsWith('auth.')) {
                console.error('location', location)
                router.get(location);
            }
        })
        .catch((error) => {

            processing.value = false;

            const errorCode = error.code;
            const errorMessage = error.message;
            if (errorCode == 'auth/weak-password') {
                alert('The password is too weak.');
            } else {
                console.error(errorCode, errorMessage);
            }
            console.log(error);
        });
};

const switchPwdType = ref('password');
const changePwdType = () => {
    switchPwdType.value = switchPwdType.value == 'password' ? 'text' : 'password';
};

const showLoginLink = route().current().startsWith('auth.');

watch(
    () => auth.currentUser,
    (val, oldVal) => {

        // console.error('reload? (1)', val);

        if (val) {

            alert('reload? (2)');

            // console.debug('reload!');

            router.reload();
            // router.reload({ only: ['step'], }, { preserveState: true });
            // console.error('window.location.reload()');
            window.location.reload();
        }
    });

onMounted(() => {
    if (auth.currentUser) {
        console.error('window.location.reload()');
        window.location.reload();
    }
});
</script>

<template>
    <form @submit.prevent="handleSignUp" class="max-w-md mx-auto">

        <div class="flex flex-wrap -mx-3 mb-4">
            <div class="w-full md:w-1/2 px-3 mb-3 md:mb-0">
                <!--<InputLabel for="firstname" value="Prénom" class="text-xl" />-->
                <TextInput id="firstname" type="text" class="mt-1 block w-full text-xl" v-model="form.firstname" required autocomplete="name" :placeholder="trans('Prénom')" />
                <InputError class="mt-2" :message="form.errors.firstname" />
            </div>
            <div class="w-full md:w-1/2 px-3">
                <!--<InputLabel for="lastname" value="Nom" class="text-xl" />-->
                <TextInput id="lastname" type="text" class="mt-1 block w-full text-xl" v-model="form.lastname" required autocomplete="name" :placeholder="trans('Nom')" />
                <InputError class="mt-2" :message="form.errors.lastname" />
            </div>
        </div>

        <div class="mt-4">
            <!--<InputLabel for="email" value="Email" />-->
            <TextInput id="email" type="email" class="mt-1 block w-full text-xl" v-model="form.email" required autocomplete="username" :placeholder="trans('Votre@email')" />
            <InputError class="mt-2" :message="form.errors.email" />
        </div>

        <div class="mt-4">
            <!--<InputLabel for="password" value="Password" />-->
            <div class="relative w-full">
                <div class="absolute inset-y-0 right-0 flex items-center px-2">
                    <label @click="changePwdType()" class="px-2 py-1 text-sm text-gray-600 dark:text-gray-300 hover:text-gray-800 font-mono cursor-pointer" for="password">
                        <svg v-show="switchPwdType == 'password'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <svg v-show="switchPwdType != 'password'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                        </svg>
                        <!-- show -->
                    </label>
                </div>
                <TextInput id="password" :type="switchPwdType" class="mt-1 block w-full text-xl" v-model="form.password" required autocomplete="new-password" :placeholder="trans('Votre mot de passe')" />
            </div>

            <InputError class="mt-2" :message="form.errors.password" />
        </div>

        <div class="mt-4">
            <!--<InputLabel for="password_confirmation" value="Confirm Password" />-->
            <TextInput id="password_confirmation" :type="switchPwdType" class="mt-1 block w-full text-xl" v-model="form.password_confirmation" required autocomplete="new-password" :placeholder="trans('Répétez votre mot de passe')" />
            <InputError class="mt-2" :message="form.errors.password_confirmation" />
        </div>

        <div class="flex items-center justify-center mt-8">
            <Link v-if="showLoginLink" :href="route('auth.login', { locale: locale })" class="underline text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-gray-800">
            {{ trans('Déjà inscrit ?') }}
            </Link>
            <PrimaryButton :class="{ 'opacity-25': form.processing || processing || auth.currentUser }" :disabled="form.processing || processing || auth.currentUser">
                {{ trans('S\'inscrire') }}
            </PrimaryButton>
        </div>

        <!-- <pre class="text-red-500">form: {{ form }}</pre> -->
        <!-- <pre>
            form.processing: {{ form.processing }}
            processing: {{ processing }} 
            </pre>
        <pre class="text-purple-500">auth.currentUser: {{ auth.currentUser }}</pre> -->
    </form>
</template>
